import { render, staticRenderFns } from "./columnWidth-editor.vue?vue&type=template&id=644f1fe7&scoped=true"
import script from "./columnWidth-editor.vue?vue&type=script&lang=js"
export * from "./columnWidth-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f1fe7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644f1fe7')) {
      api.createRecord('644f1fe7', component.options)
    } else {
      api.reload('644f1fe7', component.options)
    }
    module.hot.accept("./columnWidth-editor.vue?vue&type=template&id=644f1fe7&scoped=true", function () {
      api.rerender('644f1fe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/columnWidth-editor.vue"
export default component.exports